var _circle, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    fill: "#C9F7FC",
    stroke: "#95E9F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8479_132371",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8479_132371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 29.85C17.9 28.9667 18.9458 28.2708 20.1375 27.7625C21.3292 27.2542 22.6167 27 24 27C25.3833 27 26.6708 27.2542 27.8625 27.7625C29.0542 28.2708 30.1 28.9667 31 29.85V17H17V29.85ZM24 25C24.9667 25 25.7917 24.6583 26.475 23.975C27.1583 23.2917 27.5 22.4667 27.5 21.5C27.5 20.5333 27.1583 19.7083 26.475 19.025C25.7917 18.3417 24.9667 18 24 18C23.0333 18 22.2083 18.3417 21.525 19.025C20.8417 19.7083 20.5 20.5333 20.5 21.5C20.5 22.4667 20.8417 23.2917 21.525 23.975C22.2083 24.6583 23.0333 25 24 25ZM17 33C16.45 33 15.9792 32.8042 15.5875 32.4125C15.1958 32.0208 15 31.55 15 31V17C15 16.45 15.1958 15.9792 15.5875 15.5875C15.9792 15.1958 16.45 15 17 15H31C31.55 15 32.0208 15.1958 32.4125 15.5875C32.8042 15.9792 33 16.45 33 17V31C33 31.55 32.8042 32.0208 32.4125 32.4125C32.0208 32.8042 31.55 33 31 33H17ZM19 31H29V30.75C28.3 30.1667 27.525 29.7292 26.675 29.4375C25.825 29.1458 24.9333 29 24 29C23.0667 29 22.175 29.1458 21.325 29.4375C20.475 29.7292 19.7 30.1667 19 30.75V31ZM24 23C23.5833 23 23.2292 22.8542 22.9375 22.5625C22.6458 22.2708 22.5 21.9167 22.5 21.5C22.5 21.0833 22.6458 20.7292 22.9375 20.4375C23.2292 20.1458 23.5833 20 24 20C24.4167 20 24.7708 20.1458 25.0625 20.4375C25.3542 20.7292 25.5 21.0833 25.5 21.5C25.5 21.9167 25.3542 22.2708 25.0625 22.5625C24.7708 22.8542 24.4167 23 24 23Z",
    fill: "#004C92"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassportIcon);
export default __webpack_public_path__ + "static/media/passport_icon.2b5a2ef378e0a1737ef6c5f9749c2a87.svg";
export { ForwardRef as ReactComponent };